(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-template"]) return;
  try {
    
function initializeContactSmsConsent(root) {
  root.querySelectorAll('[data-sms-consent]').forEach(function (group) {
    if (group.dataset.smsInitialized) return;
    group.dataset.smsInitialized = 'true';
    const form = group.closest('form');
    const yes = group.querySelector('[data-sms-yes]');
    const no = group.querySelector('[data-sms-no]');
    const phone = form.querySelector('#ContactFormPhone');
    const record = group.querySelector('[data-sms-record]');
    const recordedAt = group.querySelector('[data-sms-recorded-at]');
    const originalPhonePlaceholder = phone.placeholder;
    const originalPhoneRequired = phone.required;
    function updateConsent(source) {
      if (source === yes && yes.checked) no.checked = false;
      if (source === no && no.checked) yes.checked = false;
      phone.required = originalPhoneRequired || yes.checked;
      phone.setAttribute('aria-required', String(phone.required));
      phone.placeholder = yes.checked ? phone.dataset.smsPhonePlaceholder : originalPhonePlaceholder;
      record.value = yes.checked ? 'Opted in' : no.checked ? 'Opted out' : 'Not provided';
      recordedAt.value = yes.checked || no.checked ? new Date().toISOString() : '';
    }
    yes.addEventListener('change', function () { updateConsent(yes); });
    no.addEventListener('change', function () { updateConsent(no); });
    updateConsent(null);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initializeContactSmsConsent(document); });
} else {
  initializeContactSmsConsent(document);
}
document.addEventListener('shopify:section:load', function (event) { initializeContactSmsConsent(event.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ik-gift-paths"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-ik-gift-paths] details[open]').forEach((group) => {
    if (!group.contains(event.target)) group.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-ik-gift-paths] details[open]').forEach((group) => {
    const restoreFocus = group.contains(document.activeElement);
    group.open = false;
    if (restoreFocus) {
      event.preventDefault();
      group.querySelector('summary').focus();
    }
  });
});
document.addEventListener('toggle', (event) => {
  const group = event.target;
  if (!group.matches?.('[data-ik-gift-paths] details') || !group.open) return;
  group.closest('[data-ik-gift-paths]').querySelectorAll('details[open]').forEach((other) => {
    if (other !== group) other.open = false;
  });
}, true);

  } catch(e) { console.error(e); }
})();
})();
